import { FC, useState } from 'react'

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Collapse, IconButton } from '@mui/material'
import {
  TableCellStyled,
  TableRowStyled,
  // ModalJustify,
  Select,
  Row,
  TableStyled,
  TableHeadStyled,
  Span,
  TableBodyStyled,
  ModalJustify,
  Input
} from 'components'
import { InfoIcon, DownloadIcon, ViewFileIcon, DeleteIcon } from 'components/Icons'
import { useToggle, useFile, useModal, useAuth } from 'hooks'
import moment from 'moment'
import { RequestCreateItemAnalise } from 'services/NGT/AnalyzeCRE'
import { FORMAT, COLORS } from 'utils'
import { TipoPendencia } from 'utils/types'
import { string } from 'yup'

export interface ICollapsibleTable {
  row: RequestCreateItemAnalise
  listTipoDoc: TipoPendencia[]
  handleLiberado: (_data) => void
  handleQtdPendencias: (_data) => void
  handleDescricaoAnexo: (_data) => void
  handleObservacaoMovDocItem: (_data) => void
  novaAnalise?: boolean
  handleDeletePendency?: (_data: number | String, isIdItemCre: Boolean) => void
  isChecklistAnalysis?: boolean
}

export const CollapsibleTable: FC<ICollapsibleTable> = ({
  row,
  listTipoDoc,
  novaAnalise,
  handleLiberado,
  handleQtdPendencias,
  handleDescricaoAnexo,
  handleObservacaoMovDocItem,
  handleDeletePendency,
  isChecklistAnalysis
}) => {
  const { viewFile, downloadFile } = useFile()
  const [showModal, toggleModal] = useToggle(false)
  const { showModal: showModalOpen } = useModal()

  const [open, setOpen] = useState(false)
  const [txJustificativa, setTxJustificativa] = useState<string>('')

  const findTipoDoc = (id: number): string => {
    if (listTipoDoc) {
      const index = listTipoDoc.findIndex((el) => el.idTipoPendencia === id)
      return listTipoDoc[index]?.txDescricao || ''
    } else {
      return ''
    }
  }

  const getQtdPendente = (dtAnexado: string): number => {
    if (moment(dtAnexado).format('YYYY') === '0001') {
      return 0
    }

    return Number(moment().diff(moment(dtAnexado), 'days'))
  }


  const handleShowModalDelete = (creItemId: number | String, isIdItemCre: Boolean, idMov: number) => {
    if (idMov > 0 && typeof creItemId == 'string' && isIdItemCre == false) {
      creItemId = idMov
    }

    showModalOpen({
      handleConfirm: () => handleDeletePendency(creItemId, isIdItemCre),
      message: 'Tem certeza de que deseja deletar essa pendência? Essa ação é irreversível'
    })
  }

  const isAChecklistItemToAprove = (isChecklistAnalysis: boolean, row: RequestCreateItemAnalise): boolean => {
    if (isChecklistAnalysis) {
      if (row.cdStatus === 'Aprovado' && (!row.flLiberado || row.retornoAnalise === "0001-01-01T00:00:00")) return true
    }
    return false;
  }

  const disableAproveFieldConditions = (row: RequestCreateItemAnalise) => {
    if (isAChecklistItemToAprove(isChecklistAnalysis, row)) return false;

    if (!row.idMovDocumento ||
      [null, 'Pendente', 'Aprovado', 'Recusado'].includes(
        row?.cdStatus
      ) ||
      !novaAnalise) return true;

    return false;
  }
  return (
    <>
      <TableRowStyled>
        <TableCellStyled>
          {row.cdStatus === 'Analisar' || isAChecklistItemToAprove(isChecklistAnalysis, row) ? (
            <Select
              listOptions={[
                { label: 'Liberar', value: 'item-aprovado' },
                { label: 'Recusar', value: 'item-recusado' }
              ]}
              disabled={disableAproveFieldConditions(row)}
              formValue={row.id}
              placeholder="Analisar"
              value={row.liberado ? String(row.liberado) : ''} // Garante que o valor seja uma string; adicionada verificação para evitar undefined
              onChange={handleLiberado} // Chama a função handleLiberado ao mudar a seleção
              width="100px"
            />
          ) : (
            <Span text={row.cdStatus ? row.cdStatus : 'Pendente'} />
          )}
        </TableCellStyled>
        <TableCellStyled>
          {findTipoDoc(row.tipoPendenciaId) || '- - - - -'}
        </TableCellStyled>
        <TableCellStyled>
          {!novaAnalise ? (
            row.txDescricaoAnexo || '- - -'
          ) : (
            <Input
              formValue={row.id || ''}
              value={row.txDescricaoAnexo || ''}
              onChange={handleDescricaoAnexo}
              disabled={!row.gedExternalId}
            />
          )}
        </TableCellStyled>
        <TableCellStyled align="center">
          {!novaAnalise ? (
            row.qtPendencias || '- - - - -'
          ) : (
            <Input
              formValue={String(row.id)}
              value={String(row.qtPendencias)}
              min={0}
              disabled={
                !row.gedExternalId ||
                row.historico?.length === 0 ||
                row.cdStatus !== 'Analisar'
              }
              onChange={handleQtdPendencias}
            />
          )}
        </TableCellStyled>
        <TableCellStyled align="center">
          <InfoIcon
            cursor="pointer"
            onClick={() => {
              setTxJustificativa(row.txJustificativa)
              toggleModal()
            }}
            disabled={!row.txJustificativa}
          />
        </TableCellStyled>
        <TableCellStyled align="center">
          {row.vlCalcRisco ? FORMAT.currency(row.vlCalcRisco) : 'R$ 0,00'}
        </TableCellStyled>
        <TableCellStyled align="center">
          {row.cdMatricula || '- - - - - -'}
        </TableCellStyled>
        <TableCellStyled align="center">
          {FORMAT.formatDDMMYYYY(row.dtLiberacao) || '- - - - - -'}
        </TableCellStyled>
        <TableCellStyled align="center">
          <Row alignItems="center">
            <ViewFileIcon
              onClick={() =>
                row.gedExternalId && viewFile({ gedExternalID: Number(row.gedExternalId) })
              }
              marginTop="0.5rem"
              marginRight="auto"
              marginLeft="auto"
              cursor="pointer"
              disabled={!row.gedExternalId}
            />
            <DownloadIcon
              onClick={() =>
                row.gedExternalId && downloadFile({ gedExternalID: Number(row.gedExternalId) })
              }
              marginRight="auto"
              marginLeft="auto"
              cursor="pointer"
              disabled={!row.gedExternalId}
            />
            <DeleteIcon
              onClick={() => handleShowModalDelete(row.idCreItem ? row.idCreItem : row.id, row.idCreItem > 0 ? true : false, row.idMovDocumento)}
              cursor="pointer"
              disabled={!novaAnalise}
            />
          </Row>
        </TableCellStyled>
        <TableCellStyled>
          {row?.historico?.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCellStyled>
      </TableRowStyled>
      {/* //! INICIO TABLE COLLAPSED */}
      <TableRowStyled style={{ display: !open && 'none' }}>
        <TableCellStyled style={{ padding: 0 }} colSpan={12}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <TableStyled size="small">
              <TableHeadStyled
                backgroundColor={COLORS.lightGray}
                textColor={COLORS.black}
              >
                <TableRowStyled>
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled colSpan={6} align="center">
                    Observação
                  </TableCellStyled>
                  <TableCellStyled align="center" padding="checkbox">
                    Justificativa
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    Valor Risco Lib.
                  </TableCellStyled>
                  <TableCellStyled align="center">Matrícula</TableCellStyled>
                  <TableCellStyled align="center">
                    Data Lib / Rec
                  </TableCellStyled>
                  <TableCellStyled align="center">Ações</TableCellStyled>
                </TableRowStyled>
              </TableHeadStyled>
              <TableBodyStyled>
                {row?.historico?.map((collapseRow, index) => (
                  <TableRowStyled key={index}>
                    <TableCellStyled />
                    <TableCellStyled />
                    <TableCellStyled colSpan={6} align="center">
                      {!novaAnalise ? (
                        collapseRow.txObservacaoMovDocItem || '- - -'
                      ) : row.cdStatus !== 'Analisar' ? (
                        collapseRow.txObservacaoMovDocItem || '- - -'
                      ) : (
                        <Input
                          formValue={String(collapseRow.idMovDocumentoItem)}
                          value={collapseRow.txObservacaoMovDocItem}
                          onChange={handleObservacaoMovDocItem}
                        />
                      )}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      <InfoIcon
                        cursor="pointer"
                        onClick={() => {
                          setTxJustificativa(collapseRow.txJustificativa)
                          toggleModal()
                        }}
                        disabled={!collapseRow.txJustificativa}
                      />
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {collapseRow.vlLiberado !== null
                        ? FORMAT.currency(collapseRow.vlLiberado)
                        : '---'}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {collapseRow.cdMatriculaMovItem || '---'}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {FORMAT.formatDDMMYYYY(collapseRow.dtLibRecMovDocItem) ||
                        '---'}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      <Row alignItems="center">
                        <ViewFileIcon
                          onClick={() =>
                            viewFile({
                              gedExternalID: Number(collapseRow.cdGedExternalId)
                            })
                          }
                          disabled={!collapseRow.cdGedExternalId}
                          marginTop="0.5rem"
                          marginRight="auto"
                          marginLeft="auto"
                          cursor="pointer"
                        />
                        <DownloadIcon
                          onClick={() =>
                            downloadFile({
                              gedExternalID: Number(collapseRow.cdGedExternalId)
                            })
                          }
                          disabled={!collapseRow.cdGedExternalId}
                          marginRight="auto"
                          marginLeft="auto"
                          cursor="pointer"
                        />
                      </Row>
                    </TableCellStyled>
                  </TableRowStyled>
                ))}
              </TableBodyStyled>
            </TableStyled>
          </Collapse>
        </TableCellStyled>
      </TableRowStyled>
      <ModalJustify
        showModal={showModal}
        toggleModal={toggleModal}
        defaultValue={txJustificativa}
        txJustificativa={txJustificativa}
        viewMode
      />
    </>
  )
}
